import { useEffect, useRef, useState } from 'react';
export function useHover() {
    const [value, setValue] = useState(false);
    const ref = useRef(null);
    const handleMouseOver = () => setValue(true);
    const handleMouseOut = () => setValue(false);
    useEffect(() => {
        const node = ref.current;
        if (!node)
            return;
        node === null || node === void 0 ? void 0 : node.addEventListener('mouseover', handleMouseOver);
        node === null || node === void 0 ? void 0 : node.addEventListener('mouseout', handleMouseOut);
        return () => {
            node === null || node === void 0 ? void 0 : node.removeEventListener('mouseover', handleMouseOver);
            node === null || node === void 0 ? void 0 : node.removeEventListener('mouseout', handleMouseOut);
        };
    }, []);
    return [ref, value];
}
//# sourceMappingURL=useHover.js.map